import { bool, func, object } from 'prop-types';
import React, { useMemo } from 'react';

import ModalComponent from '@components/Share/ModalComponent';
import { Image, Link, Text } from '@sitecore-jss/sitecore-jss-react';
import { SG_SITE_NAME } from '@utils/constant';
import { isAtSiteName } from '@utils/customsHook/useIsAtSiteName';

const PartnerSpecialModal = ({
  isShow,
  handleCloseModalPartner,
  partnerData,
  layoutData
}) => {
  const isAllowedNewUi = useMemo(() => isAtSiteName(SG_SITE_NAME), []);

  return (
    <ModalComponent
      isShow={isShow}
      onCloseHandler={handleCloseModalPartner}
      cssClass={['osim-popup--no-padding', isAllowedNewUi ? 'partner-special-popup__v2-modal' : ''].join(' ')}
    >
      <div className={['partner-special-popup', isAllowedNewUi ? 'partner-special-popup__v2' : ''].join(' ')}>
        <div className='partner-special-popup__image'>
          {isAllowedNewUi ? (
            <div className='partner-special-popup__image-wrapper'>
              <Image field={partnerData?.['Partner Banner']} className='desktop-image' />
              <Image field={partnerData?.['Partner Banner Mobile']} className='mobile-image' />
            </div>
          ) : (
            <>
              <Image field={partnerData?.['Partner Banner']} className='desktop-image' />
              <Image field={partnerData?.['Partner Banner Mobile']} className='mobile-image' />
            </>
          )}
        </div>

        {isAllowedNewUi ? (
          <div className='partner-special-popup__content'>
            <h6 className='partner-name'>{partnerData?.['Partner Name']}</h6>

            {partnerData?.['Partner Description'] ? (
              <p className='partner-description'>{partnerData['Partner Description']}</p>
            ) : (
              <></>
            )}

            {partnerData?.['Promo Code'] ? (
              <p className='partner-promo-code'>
                <Text tag='span' className='title' field={layoutData?.['Promo Code Label']} />
                <span className='code'>{partnerData['Promo Code']}</span>
              </p>
            ) : (
              <></>
            )}

            {partnerData?.['Terms And Conditions'] ? (
              <div className='partner-tac'>
                <Text tag='p' className='partner-tac__title' field={layoutData?.['Terms And Conditions Label']} />
                <p
                  dangerouslySetInnerHTML={{ __html: partnerData['Terms And Conditions'] }}
                  className='partner-tac__detail'
                />
              </div>
            ) : (
              <></>
            )}

            <div className='partner-ctas'>
              {partnerData?.['Partner Website'] ? (
                <Link
                  field={{ href: partnerData['Partner Website'] }}
                  className='btn btn-primary' target='_blank'
                >
                  <Text field={layoutData?.['Redeem Online Button Text']} />
                </Link>
              ) : (
                <></>
              )}

              {partnerData?.['Partner Store Locator'] ? (
                <Link
                  field={{ href: partnerData['Partner Store Locator'] }}
                  className='btn btn-primary' target='_blank'
                >
                  <Text field={layoutData?.['Locate A Store Button Text']} />
                </Link>
              ) : (
                <></>
              )}
            </div>
          </div>
        ) : (
          layoutData?.['See More Button Text']?.value ?
            (
              <>
                <Link
                  field={{ href: partnerData?.['Partner Website'] }}
                  className='partner-special-popup__btn btn btn-primary'
                >
                  <Text field={layoutData?.['See More Button Text']} />
                </Link>
              </>
            ) : (
              <></>
            )
        )}
      </div>
    </ModalComponent>
  );
};

PartnerSpecialModal.propTypes = {
  isShow: bool,
  handleCloseModalPartner: func,
  partnerData: object,
  layoutData: object
};

export default PartnerSpecialModal;
